import './style.scss'

export interface FeatureChipProps {
    label: string
    checked: boolean
    onChange: (checked: boolean) => void
}

export const FeatureChip: React.FC<FeatureChipProps> = ({ label, checked, onChange }) => (
    <label className={`feature-chip ${checked ? 'feature-chip--checked' : ''}`}>
        <input
            type="checkbox"
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
        />
        <span className="feature-chip__box">
            {checked && (
                <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 4L3.5 6.5L9 1" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            )}
        </span>
        <span className="feature-chip__label">{label}</span>
    </label>
)

export default FeatureChip